// extracted by mini-css-extract-plugin
module.exports = {"card":"CreateYourAccount_card__umWii","checkInbox":"CreateYourAccount_checkInbox__P2aos"};